export const CARD_PUBLISHED_STATUS = {
    released: "Released"
}